import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Container } from "@material-ui/core";
import Navbar from "./components/globalComponents/Navbar/Navbar.js";
import Footer from "./components/globalComponents/Footer/Footer.js";
import Home from "./components/Home/Home.js";
import Research from "./components/Research/Research.js";
import Contact from "./components/Contact/Contact.js";
import "./App.css";
require("dotenv").config();

function App() {
    return (
        <BrowserRouter>
            <Navbar />
            <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/contact-us" element={<Contact />} />
                <Route path="/research" element={<Research />} />
            </Routes>
            <Footer />
        </BrowserRouter>
    );
}

export default App;
